import { LenderProfile, SendOcaLinkInput } from '@trnsact/trnsact-shared-types';
import { SelectOption } from 'global';
import { SendApplicationFormValues } from '../types';
import { SendApplicationPortalConfig } from 'modules/portalConfigurations/sendApplication/types';

export const getLenderProfilesWithOcaOptions = (
  lenderProfiles: LenderProfile[],
  portalConfigurationConfig?: SendApplicationPortalConfig
): SelectOption[] => {
  const excludedLenderProfileIds = portalConfigurationConfig?.excludedLenderProfileIds ?? [];

  return (
    lenderProfiles
      .filter(({ lenderProfileId }) => !excludedLenderProfileIds.includes(lenderProfileId))
      .map(({ lenderProfileId, name }) => ({ label: name!, value: lenderProfileId })) ?? []
  );
};

export const formatFormValuesToSendOcaLinkPayload = (
  formValues: SendApplicationFormValues
): SendOcaLinkInput & {
  isPromoteFlyer: boolean;
  flyerMeta: {
    listOfInventory: string[];
    finance: { term: number; rate: number; downPayment: number };
  };
} => {
  return {
    equipment: formValues.equipment,
    sendMethod: formValues.sendMethod,
    contactDetails: formValues.contactDetails,
    isPromoteFlyer: formValues.isPromoteFlyer,
    lenderProfileId: formValues.lenderProfileId,
    flyerMeta: {
      finance: {
        rate: formValues.finance.rate ?? 0,
        downPayment: formValues.finance.downPayment ?? 0,
        term: formValues.finance.term ? Number(formValues.finance.term) : 0,
      },
      listOfInventory: formValues.listOfInventory,
    },
  };
};
